module.exports = __webpack_public_path__ + "static/media/6.23_preview.0987fea4.png";